import { external, production } from './environment.production'

export const environment = {
  ...production,
  ...external,
  adobeLaunchEnv: 'production',
  irrURLPrefixEast1:
    'https://irr-investment-retail-rest-external.ecs.us-east-1.retp.c1.vanguard.com/',
  irrURLPrefixWest2:
    'https://irr-investment-retail-rest-external.ecs.us-west-2.retp.c1.vanguard.com/',
  aemCaaSURL:
    'https://retaemdisp.retp.c1.vanguard.com/content/ret/funds/fundprofile/public.caas.json',
  vfeURLPrefix: 'https://personal.vanguard.com/us/',
  vfeNewURLPrefix: 'https://personal1.vanguard.com/usa/',
  priceHistorySearch:
    'https://personal.vanguard.com/us/funds/tools/pricehistorysearch?FundId=',
  priceHistorySearchExternalFunds:
    'https://personal.vanguard.com/us/FundsSearchPriceHistoryFA?FundId=',
  compareURLPrefix:
    'https://investor.vanguard.com/tools-calculators/etf-fund-comparison-tool?Ticker=',
  investorPrefix: 'https://investor.vanguard.com/',
  allocationMfsRedirectUrl:
    'https://investor.vanguard.com/investment-products/mutual-funds/profile/',
  allocationEtfsRedirectUrl:
    'https://investor.vanguard.com/investment-products/etfs/profile/',
  performanceEtfInformation:
    'https://investor.vanguard.com/investing/profiles/etf-performance-information',
  performance529Information:
    'https://investor.vanguard.com/investing/profiles/529-portfolio-performance-information',
  performanceMFInformation:
    'https://investor.vanguard.com/investing/profiles/mutual-fund-performance-information',
  accountServiceFee: 'https://investor.vanguard.com/investing/account-fees',
  pcfUrl: 'https://etfportal.vanguard.com/extrapi/v2/us/standard/',
  swapFileUrl:
    'https://aemdam.assets.vgdynamic.info/assets/corp/fund_communications/pdf_publish/us-products/VCMDXcustomswap.pdf',
  advisorsStategyFund:
    'https://advisors.vanguard.com/investments/products/vcmdx/vanguard-commodity-strategy-fund-admiral-shares#portfolio',
  afterTaxReturns:
    'https://investor.vanguard.com/investing/profiles/after-tax-returns',
  literaturePrefix: 'https://personal.vanguard.com/',
  vfaPersonal1Url: 'https://personal1.vanguard.com/',
  externalUrl: 'https://personal.vanguard.com/',
  newExternalUrl: 'https://personal1.vanguard.com/',
  internalUrl: 'https://apii.ecs.us-east-1.retp.c1.vanguard.com/',
  nonVanguardFundsViewableFlag: true,
  irePrettyUrlEast1: 'https://api.vanguard.com/rs/ire/01/',
  canonicalBaseUrl: 'https://investor.vanguard.com',
  vgnHFUrl: 'https://n4v.web.vanguard.com',
  GATEKEEPER_APP_PREFIX: 'TRJ',
  GATEKEEPER_ENVIRONMENT_TAG: 'PROD',
  quickTicketMfeUrl: 'https://tradecx.web.vanguard.com',
  prospectusAuditUrl: 'https://personal1.vanguard.com',
}
